import * as React from "react";
import {observable} from "mobx";
import {observer} from "mobx-react";
import {IGDPRItem} from "components/signup/shared/IGDPRItem";
import {UIState} from "data/UIState";
import {GDPRItemComponent} from "components/signup/shared/GDPRItemComponent";

interface Props {
  onStatusChange:(status:boolean)=>void;  // lets parent know whether all checks are good
  checkFailed:boolean;                    // triggers error display
}

@observer
export class GDPR extends React.Component<Props> {

  @observable gDPRItems:Array<IGDPRItem>;

  constructor(props:Props) {
    super(props);
    this.gDPRItems = new Array<IGDPRItem>();
    this.gDPRItems.push({
      id:'privacy_policy',
      accepted:false,
      initialDescription:UIState.settings.PRIVACY_POLICY_AGREE_DESCRIPTION,
      profileDescription:'',
    });
    for(let i=0;i<UIState.settings.GDPR_ITEMS.length;i++) {
      this.gDPRItems.push( JSON.parse(JSON.stringify(UIState.settings.GDPR_ITEMS[i])) );
    }
  }

  /**
   * Computes whether all terms have been accepted and returns the
   * result to the parent.
   */
  handleStatusChange = () => {
    let accepted = true;
    for(let i=0;i<this.gDPRItems.length;i++) {
      if(!this.gDPRItems[i].accepted) {
        accepted = false;
        break;
      }
    }
    this.props.onStatusChange(accepted);
  }

  render() {
    return(
      <div className="form-element">
        <label id={"gdpr-label"}>Your Privacy and Consent</label>
        <p className="hint">Please <a target="_blank" href={UIState.settings.TOS_DOC}>review our privacy policy</a> and then agree to the following:</p>
        <ul className={"reset"} role={"group"} aria-labelledby={'gdpr-label'}>
        {this.gDPRItems.map((item:IGDPRItem)=><GDPRItemComponent key={item.id} item={item} checkGDPR={this.props.checkFailed} onClick={this.handleStatusChange} />)}
        </ul>
      </div>
    );
  }
}
